import { find } from 'lodash';
import { getStore } from '../store';
/**
 * 权限等级表
 */

export var PrivilegeLevel;

(function (PrivilegeLevel) {
  /**
   * 表示无权限访问
   */
  PrivilegeLevel[PrivilegeLevel["none"] = 0] = "none";
  /**
   * 表示有权限访问 不可以修改删除
   */

  PrivilegeLevel[PrivilegeLevel["view"] = 1] = "view";
  /**
   * 有权限访问 可以修改 不可以删除
   */

  PrivilegeLevel[PrivilegeLevel["modify"] = 2] = "modify";
  /**
   * 最高权限
   */

  PrivilegeLevel[PrivilegeLevel["full"] = 3] = "full";
})(PrivilegeLevel || (PrivilegeLevel = {}));
/**
 * 根据权限路径获取权限节点
 * @param privilegeNodes 权限树
 * @param path 权限路径
 */


function getPrevilegeLevelByPath(privilegeNodes, path) {
  var names = path.split('.');
  var processedPrivilegeNodes = privilegeNodes;
  var currentPrivilege;

  for (var _i = 0, names_1 = names; _i < names_1.length; _i++) {
    var name_1 = names_1[_i];
    currentPrivilege = find(processedPrivilegeNodes, {
      name: name_1
    });

    if (currentPrivilege) {
      processedPrivilegeNodes = currentPrivilege.children;
    } else {
      return PrivilegeLevel.none;
    }
  }

  return currentPrivilege ? currentPrivilege.level : PrivilegeLevel.none;
}
/**
 * 检查当前用户是否满足指定权限
 * @param path 权限路径
 * @param level 权限等级
 */


function check(path, level) {
  var _a = getStore().getState().user.privileges,
      privileges = _a === void 0 ? [] : _a;
  var userLevel = getPrevilegeLevelByPath(privileges, path);
  return PrivilegeLevel[userLevel] >= PrivilegeLevel[level];
}
/**
 * 检查当前用户是否有权限信息
 */


function hasPrivilege() {
  var privileges = getStore().getState().user.privileges;
  return !!privileges && !!privileges.length;
}

export var privilege = {
  check: check,
  hasPrivilege: hasPrivilege
};